import { render, staticRenderFns } from "./RequestsHeader.vue?vue&type=template&id=44dc372a&scoped=true&"
import script from "./RequestsHeader.vue?vue&type=script&lang=js&"
export * from "./RequestsHeader.vue?vue&type=script&lang=js&"
import style0 from "./RequestsHeader.vue?vue&type=style&index=0&id=44dc372a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44dc372a",
  null
  
)

export default component.exports